import { Component, OnInit } from "@angular/core";
import { MatSelectChange as MatSelectChange } from "@angular/material/select";
import { Store } from "@ngrx/store";
import { NgxLoggerLevel } from "ngx-logger";
import { Observable } from "rxjs";
import { SetLogLevel } from "../../logging/state/logging-state/logging.actions";
import { LoggingState } from "../../logging/state/logging-state/logging.reducer";
import { selectLoggingState } from "../../logging/state/logging-state/logging.selectors";

@Component({
  selector: "app-user-preferences",
  templateUrl: "./user-preferences.component.html",
  styleUrls: ["./user-preferences.component.scss"],
  standalone: false,
})
export class UserPreferencesComponent implements OnInit {
  loggingState$: Observable<LoggingState> =
    this.store.select(selectLoggingState);

  logLevelOptions = [
    {
      label: `Trace`,
      value: NgxLoggerLevel.TRACE,
    },
    {
      label: `Debug`,
      value: NgxLoggerLevel.DEBUG,
    },
    {
      label: `Info`,
      value: NgxLoggerLevel.INFO,
    },
    {
      label: `Warn`,
      value: NgxLoggerLevel.WARN,
    },
    {
      label: `Error`,
      value: NgxLoggerLevel.ERROR,
    },
    {
      label: `Fatal`,
      value: NgxLoggerLevel.FATAL,
    },
    {
      label: `Off`,
      value: NgxLoggerLevel.OFF,
    },
  ];

  constructor(private store: Store<any>) {}

  ngOnInit() {}

  selectLogLevel(event: MatSelectChange) {
    this.store.dispatch(new SetLogLevel(event.value));
  }
}
